import React from 'react';
import {i18n} from '../i18n';
import styled from 'styled-components';

// import { BlackjackGameModel } from '../store/models/BlackjackGameModel';

const TranslatedSpan = styled.span`
	white-space: pre-line;
`

export class Localize extends React.Component {
	render(){
		const p = this.props.phrase || this.props.p;
		return (
			<TranslatedSpan style={this.props.style}>
				{i18n.t(p).split("\\n").map((string, i) => (
					<span key={i}>{!!i && <br/>}{string}</span>
				))}
			</TranslatedSpan>
		);
	}
}
